import { TwoValueTool } from "./_helpers";
/** The logic for the DC Power calculator */
export class BatteryLifeCalculator extends TwoValueTool {
    constructor() {
        super("tools-battery-calculator", ['input-capacity', 'input-current']);
    }
    onCalculate() {
        let hours = +this.inputBoxes[0].value / +this.inputBoxes[1].value;
        return { result: `${hours} hours`, pre: "Your battery will last:" };
    }
}
;
